



































































































import {Component, Watch, Vue} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import {$, Collection, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {UploadConfig} from '@/config/upload.config'
import Responsavel from '@/model/resource/Responsavel'
import StatusSms from '@/model/resource/StatusSms'
import ResponsavelConfigEmail from '@/model/resource/ResponsavelConfigEmail'
import ResponsavelConfigEmailRequest from '@/model/request/ResponsavelConfigEmailRequest'
import ModalUpload from '@/components/modals/ModalUpload.vue'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import {getResponsavel, ItrackCollection} from '@/helpers'
import * as Helper from '@/helpers'
import ConfigEmailRegraEnvio from '@/model/resource/ConfigEmailRegraEnvio'

const metaInfo = () => ({
  title: $.t('view.manage.emailNotificationSettings.title'),
})

@Component({
  metaInfo,
  components: { ModalUpload },
})
export default class ManageEmailNotificationsSettingsView extends Vue {
  @Action('auth/auth') auth!: Function
  @Getter('auth/responsavel') responsavelCache!: Responsavel

  AppConfig = AppConfig
  UploadConfig = UploadConfig

  config = new ResponsavelConfigEmailRequest()
  possibleEmailStatus = new Collection(StatusSms)
  allTipoOcorrencia = ItrackCollection.allTipoOcorrencia
  ocorrencias = new Collection(TipoOcorrencia)
  allConfigEmailRegraEnvio = new Collection(ConfigEmailRegraEnvio)

  changingHeader = true

  async mounted() {
    this.config.responsavel = this.responsavelCache.clone()
    await this.config.populate('load')
    await this.possibleEmailStatus.query()
    await this.allTipoOcorrencia.query()
    await this.allConfigEmailRegraEnvio.query()

    const filterNaoDevolvida = this.allTipoOcorrencia.items.filter((item) =>
      // @ts-ignore
      (item.responsavel.$id === getResponsavel().$id || !item.responsavel.$id))

    this.ocorrencias = Helper.collect(TipoOcorrencia, filterNaoDevolvida)
  }

  get uploadTitle() {
    return this.changingHeader
            ? this.$t('view.manage.emailNotificationSettings.emailHeaderImage')
            : this.$t('view.manage.emailNotificationSettings.emailFooterImage')
  }

  get bestSize() {
    return this.changingHeader
            ? this.$t('view.manage.emailNotificationSettings.bestSizeLogo')
            : this.$t('view.manage.emailNotificationSettings.bestSizeFooter')
  }

  addEmail() {
    this.config.list.push(new ResponsavelConfigEmail())
  }

  removeEmail(i: number) {
    this.config.list.splice(i, 1)
  }

  async uploadDone(urls: string[]) {
    if (!this.config.responsavel) {
      return
    }

    if (this.changingHeader) {
      this.config.responsavel.urlImgCabecalho = urls[0]
      const presignedUrl = await this.getPresignedUrl(urls[0])
      this.config.responsavel.urlImgCabecalhoView = presignedUrl != null ? presignedUrl :  urls[0]
    } else {
      this.config.responsavel.urlImgRodape = urls[0]
      const presignedUrl = await this.getPresignedUrl(urls[0])
      this.config.responsavel.urlImgRodapeView = presignedUrl != null ? presignedUrl : urls[0]
    }
  }

  async getPresignedUrl(objectUrl: string): Promise<string | null> {
    try {
      return await Helper.getPresignedUrlFromObjectUrl(objectUrl)
    } catch (e) {
      console.error(e)
      return null;
    }
  }

  async persist() {
    if (this.config.list.some((cfg) => !Boolean(cfg.statusEmail && cfg.statusEmail.idStatusPk))) {
      await Helper.abort('system.error.statusFieldCantBeEmpty')
    }

    await this.config.save()
    await this.auth()
    successAndPush('system.success.persist', 'cockpit')
  }

  changeHeader() {
    this.changingHeader = true
    this.$modal.open('upload')
  }

  changeFooter() {
    this.changingHeader = false
    this.$modal.open('upload')
  }
}
